import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["action", "import", "status"]

  connect() {
    this.locked = false
    this.importLabel = this.hasImportTarget ? this.importTarget.textContent : "Import"
  }

  beginImport(event) {
    if (this.locked) {
      event.preventDefault()
      return
    }

    this.locked = true
    this.actionTargets.forEach((element) => this.disable(element))
    if (this.hasImportTarget) this.importTarget.textContent = "Importing…"
    if (this.hasStatusTarget) this.statusTarget.hidden = false
  }

  submitEnd(event) {
    if (event.detail.success) return

    this.locked = false
    this.actionTargets.forEach((element) => this.enable(element))
    if (this.hasImportTarget) this.importTarget.textContent = this.importLabel
    if (this.hasStatusTarget) this.statusTarget.hidden = true
  }

  disable(element) {
    if ("disabled" in element) element.disabled = true
    element.classList.add("disabled")
    element.setAttribute("aria-disabled", "true")
    element.dataset.previousTabindex = element.getAttribute("tabindex") || ""
    element.setAttribute("tabindex", "-1")
  }

  enable(element) {
    if ("disabled" in element) element.disabled = false
    element.classList.remove("disabled")
    element.removeAttribute("aria-disabled")
    if (element.dataset.previousTabindex) {
      element.setAttribute("tabindex", element.dataset.previousTabindex)
    } else {
      element.removeAttribute("tabindex")
    }
    delete element.dataset.previousTabindex
  }
}
